export default __webpack_public_path__ + "static/media/3.25096146.png";